module.exports = __webpack_public_path__ + "media/svg/menu-purple-x-bd8d5f4c.svg";